import { Component } from '@angular/core';

@Component({
  selector: 'app-add-retirement-date-info',
  templateUrl: './add-retirement-date-info.component.html',
  styleUrls: ['./add-retirement-date-info.component.scss']
})
export class AddRetirementDateInfoComponent {

}
